import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import { ReceivingType } from 'src/types/receiving';
import Detail from './Detail';
import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import { ReceivingChangelogType } from 'src/types/receivingDetail';
import HistoryBlock from './HistoryBlock';
import Info from './Info';
import Grid, { GridItem } from 'src/components/Grid';
import Driver from './Driver';
import ProductsTable from './ProductsTable';
import NewProductBlock from './NewProductBlock';
import { sizes } from 'src/themes/default';
import PackingsTable from './PackingsTable';
import NewPackingBlock from './NewPackingBlock';
import ReceivingFilesBlock from './FilesBlock';
import productTypesWithoutVirtual from 'src/utils/productTypesWithoutVirtual';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface RenderComponentsPropsType {
    formRef: React.RefObject<HTMLFormElement>;
    productsFormRef: React.RefObject<HTMLFormElement>;
    data: ReceivingType | null;
    onChange: OnChangeType<EditKeysType>;
    editData: ReceivingType;
    editErrors: FormErrorsType;
    newReceiving: boolean;
    disableEdit: boolean;
    isAttributeEditDisabled: (key: string) => boolean;
    permissionEditAll: boolean;
    allowedStatuses: ConstantsCodeType[];
    receivingStatusCodes: ConstantsCodeType[];
    receivingStatusCodesObject: ConstantsCodesObjectType;
    receivingUrgentCodes: ConstantsCodeType[];
    receivingUrgentCodesObject: ConstantsCodesObjectType;
    receivingDeliveryTypeCodes: ConstantsCodeType[];
    receivingDeliveryTypeCodesObject: ConstantsCodesObjectType;

    productTypeCodes: ConstantsCodeType[];
    productTypeCodesObject: ConstantsCodesObjectType;
    receivingPackingTypeCodes: ConstantsCodeType[];
    receivingPackingTypeCodesObject: ConstantsCodesObjectType;
    receivingPalletCodes: ConstantsCodeType[];
    receivingPalletCodesObject: ConstantsCodesObjectType;
    boolNumberCodes: ConstantsCodeType[];
    boolNumberCodesObject: ConstantsCodesObjectType;
    driverCompanyCodes: ConstantsCodeType[];
    driverCompanyCodesObject: ConstantsCodesObjectType;
    receivingPriorityCodes: ConstantsCodeType[];
    receivingPriorityCodesObject: ConstantsCodesObjectType;
    receivingTypeCodes: ConstantsCodeType[];
    receivingTypeCodesObject: ConstantsCodesObjectType;
    incotermsCodes: ConstantsCodeType[];
    incotermsCodesObject: ConstantsCodesObjectType;
    lineStateCodesObject: ConstantsCodesObjectType;
    activeTab: string;
    changelog: ReceivingChangelogType | null;
    skladonUser?: number;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {
    const renderDetail = () => (
        <>
            <form ref={props.formRef}>
                <FormBlock sx={{ marginBottom: sizes.blocks_top_MG }}>
                    <Grid>
                        <GridItem cols={4}>
                            <Info
                                onChange={props.onChange}
                                editData={props.editData}
                                editErrors={props.editErrors}
                                newReceiving={props.newReceiving}
                                disableEdit={props.disableEdit}
                                permissionEditAll={props.permissionEditAll}
                                allowedStatuses={props.allowedStatuses}
                                receivingStatusCodes={props.receivingStatusCodes}
                                receivingUrgentCodes={props.receivingUrgentCodes}
                                boolNumberCodes={props.boolNumberCodes}
                                receivingPriorityCodes={props.receivingPriorityCodes}
                                skladonUser={props.skladonUser}
                            />
                        </GridItem>
                        <GridItem cols={4}>
                            <Detail
                                onChange={props.onChange}
                                editData={props.editData}
                                editErrors={props.editErrors}
                                newReceiving={props.newReceiving}
                                disableEdit={props.disableEdit}
                                receivingDeliveryTypeCodes={props.receivingDeliveryTypeCodes}
                                boolNumberCodes={props.boolNumberCodes}
                                receivingTypeCodes={props.receivingTypeCodes}
                                incotermsCodes={props.incotermsCodes}
                            />
                        </GridItem>
                        <GridItem cols={4}>
                            <Driver
                                onChange={props.onChange}
                                editData={props.editData}
                                editErrors={props.editErrors}
                                disableEdit={props.disableEdit}
                                driverCompanyCodes={props.driverCompanyCodes}
                                newReceiving={props.newReceiving}
                            />
                        </GridItem>
                    </Grid>
                </FormBlock>
            </form>
            {!props.disableEdit && (
                <FormBlock>
                    <NewProductBlock
                        data={props.editData.PRODUCTS || []}
                        onChange={(value: any) => props.onChange('PRODUCTS', value, false)}
                        disableEdit={props.disableEdit}
                        editErrors={props.editErrors}
                    />
                </FormBlock>
            )}
            <form ref={props.productsFormRef}>
                <ProductsTable
                    receivingData={props.data}
                    data={props.editData.PRODUCTS || []}
                    newReceiving={props.newReceiving}
                    onChange={(value, error, errorKey) => {
                        if (errorKey) {
                            props.onChange('PRODUCTS', value, error ?? false, errorKey);
                        } else {
                            props.onChange('PRODUCTS', value, !value.length);
                        }
                    }}
                    disableEdit={props.disableEdit}
                    productTypeCodes={productTypesWithoutVirtual(props.productTypeCodes)}
                    editErrors={props.editErrors}
                />
            </form>
            <ReceivingFilesBlock
                onChange={props.onChange}
                editData={props.editData}
                editErrors={props.editErrors}
                disableEdit={props.disableEdit}
                isAttributeEditDisabled={props.isAttributeEditDisabled}
                skladonUser={props.skladonUser}
            />

        </>
    );

    const renderHistory = () => (
        <HistoryBlock
            changelog={props.changelog}
            receivingStatusCodesObject={props.receivingStatusCodesObject}
            receivingUrgentCodesObject={props.receivingUrgentCodesObject}
            receivingDeliveryTypeCodesObject={props.receivingDeliveryTypeCodesObject}
            productTypeCodesObject={props.productTypeCodesObject}
            receivingPackingTypeCodesObject={props.receivingPackingTypeCodesObject}
            receivingPalletCodesObject={props.receivingPalletCodesObject}
            lineStateCodesObject={props.lineStateCodesObject}
            driverCompanyCodesObject={props.driverCompanyCodesObject}
            receivingPriorityCodesObject={props.receivingPriorityCodesObject}
            receivingTypeCodesObject={props.receivingTypeCodesObject}
            incotermsCodesObject={props.incotermsCodesObject}
            boolNumberCodesObject={props.boolNumberCodesObject}
            skladonUser={props.skladonUser}
        />
    );

    switch (props.activeTab) {
        case 'detail':
            return renderDetail();

        case 'history':
        default:
            return renderHistory();
    }
};

export default RenderComponents;
